import {
  DropdownMenuContentProps,
  DropdownMenuProps as RadixDropdownMenuProps,
  DropdownMenuSubProps as RadixDropdownSubMenuProps
} from '@radix-ui/react-dropdown-menu';
import { PopoverContentProps } from '@radix-ui/react-popover';

import { HintPropsType } from '../Misc/Hint';
import { TooltipPropsType } from '../Tooltip';

export enum Size {
  md = 'md',
  lg = 'lg'
}

export type SizeType = `${Size}`;

export type ItemProps = {
  draggingStarted?: boolean;
  dragging?: boolean;
};

export type ItemDataTestIdProps =
  | {
      onSelect: (event: Event) => void;
      'data-test-id': string;
    }
  | {
      onClick: React.HTMLAttributes<HTMLDivElement>['onClick'];
      'data-test-id': string;
    }
  | {
      onClick?: never;
      onSelect?: never;
      'data-test-id'?: string;
    };

export interface DropdownProps extends React.HTMLAttributes<HTMLButtonElement> {
  disabled?: boolean;
  /** The component that pops out when the dropdown menu is open */
  overlay: React.ReactNode;
  //triggerType: 'click'|'hover'|'context'
  /** The button that toggles the dropdown menu. */
  children: React.ReactNode;
  overlayClassName?: string;
  overlayStyle?: React.CSSProperties;
  visible?: RadixDropdownMenuProps['open'];
  onVisibleChange?: RadixDropdownMenuProps['onOpenChange'];
  arrow?: boolean;
  placement?: DropdownMenuContentProps['side'];
  placementOffset?: DropdownMenuContentProps['sideOffset'];
  align?: DropdownMenuContentProps['align'];
  alignOffset?: DropdownMenuContentProps['alignOffset'];
  portalled?: boolean;
  hint?: HintPropsType;
  tooltip?: TooltipPropsType;
  onCloseAutoFocus?: DropdownMenuContentProps['onCloseAutoFocus'];
  onInteractOutside?: DropdownMenuContentProps['onInteractOutside'];
  onOpenAutoFocus?: PopoverContentProps['onOpenAutoFocus'];
  size?: SizeType;
  modal?: boolean;
  footer?: React.ReactNode;
  openOnHover?: boolean;
  defaultOpen?: boolean;
  'data-test-id': string;
}

export interface DropdownSubMenuProps {
  children: React.ReactNode;
  overlay: React.ReactNode;
  overlayArrow?: boolean;
  triggerArrow?: boolean;
  placementOffset?: DropdownMenuContentProps['sideOffset'];
  alignOffset?: DropdownMenuContentProps['alignOffset'];
  open?: RadixDropdownSubMenuProps['open'];
  defaultOpen?: RadixDropdownSubMenuProps['defaultOpen'];
  onOpenChange?: RadixDropdownSubMenuProps['onOpenChange'];
  disabled?: boolean;
  size?: SizeType;
  'data-test-id': string;
}

export type ContentStyleProps = ItemProps & {
  readonly size?: SizeType;
};
